import React from 'react'
import { Typography, withStyles, Popover } from '@material-ui/core'
import styles from '../user-access/components/styles'
import { track } from '@amplitude/analytics-browser'
import { CoreButton } from 'src/components/core'

// "Meet with MCG Team" — the headless plan, which is what in-app
// authentication (the only feature using this "Get quote" popover) belongs to.
const HEADLESS_PLAN_CALL_URL = 'https://calendar.app.google/afP5X5MKDyRcVZf8A'

const UpgradePopover = props => {
  const {
    id,
    anchorEl,
    handleClose,
    open,
    header,
    content,
    accessRuleEqual,
  } = props

  const onClick = () => {
    if (header != 'Get quote') {
      track('limit_warning_upgrade', {
        from: `${accessRuleEqual}_limit_upgrade`,
      })
      window.location.href = '/pricing'
      return
    } else {
      handleClose()
      window.open(HEADLESS_PLAN_CALL_URL, '_blank')
    }
  }

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      PaperProps={{
        style: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: 16,
          padding: '24px 24px',
          width: '370px',
          boxShadow: 'none',
          backgroundImage:
            'linear-gradient(128deg, #6FB6FE 5.78%, #015FFB 112.71%)',
        },
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          gap: 16,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
          }}
        >
          <Typography fontSize={'22px'} fontWeight={500} color={'#fff'}>
            {header}
          </Typography>
          <Typography fontSize={'15px'} fontWeight={400} color={'#fff'}>
            {content}
          </Typography>
        </div>
        <img
          src={'/assets/mcg-rocket2x.png'}
          alt="rocket!"
          width={100}
          height={100}
        />
      </div>
      <CoreButton
        variant={'contained'}
        onClick={onClick}
        color="white"
        size="small"
        fullWidth
      >
        {header == 'Get quote' ? 'Contact sales' : 'See Plans & Upgrade'}
      </CoreButton>
    </Popover>
  )
}

export default withStyles(styles)(UpgradePopover)
